import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { UserProfileExperiencesEditModalComponent } from './user-profile-experiences-edit-modal.component';
import { UserProfileEditableUiModule } from '../../../user-profile-editable-ui/user-profile-editable-ui.module';
import { UserProfileEditableUiRedesignModule } from '../../../user-profile-editable-ui-redesign/user-profile-editable-ui-redesign.module';

@NgModule({
  imports: [
    CommonModule,
    UiModule,
    UserProfileEditableUiRedesignModule,
    UserProfileEditableUiModule,
  ],
  declarations: [UserProfileExperiencesEditModalComponent],
  exports: [UserProfileExperiencesEditModalComponent],
})
export class UserProfileExperiencesEditModalModule {}
